import { PalletType } from 'interfaces';

export const TARCZYNSKI_PALLET_TYPES: Record<string, PalletType> = {
   '_PALETA EUR ZIELONA EDHP': 'EDHP_PALLET',
   '_PALETA DHP ZIELONA NDHP': 'HALF_PALLET_NDHP',
   '_PALETA 600/400 ZIELONA NDHP': 'QUARTER_PALLET_CDHP',
   '_PALETA EUR': 'EURO_PALLET',
};
